import { lazy } from 'react';
import { Redirect } from 'react-router-dom';
// layouts
import HomeLayout from '../layouts/home';
import AuthGuard from '../guards/AuthGuard';

// ----------------------------------------------------------------------

const HomeRoutes = {
  path: '*',
  layout: HomeLayout,
  guard: AuthGuard,

  routes: [
    {
      exact: true,
      path: '/',
      // component: lazy(() => import('../views/LandingPage'))
      component: () => <Redirect to="/dashboard" />
    },
    {
      component: () => <Redirect to="/404" />
    }
  ]
};

export default HomeRoutes;
